import 'owl.carousel';

$(".destaques").owlCarousel({
    margin: 44,
    items: 4,
    stagePadding: 50,
    autoWidth:true,
});
